import React from "react"
import {observer} from "mobx-react"
import MesureStore from '../MesureStore'
import PrescriptionStore from '../../PrescriptionStore'
import MesureOverview from "./MesureOverview";
import {TypesMesures} from "../../../Shared/Enums/Enums";
import {isLocked, LockingElement} from "../../AppointmentValidation";
import {t} from "../../../I18n/i18n";
import {toast} from "react-toastify";

const mesure_types = require("./MesureTypes.json")

@observer
class ActiveTabs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hoveredId: undefined,
            selectedId: undefined
        }
    }

    componentDidMount() {
        PrescriptionStore.sourceData = MesureStore.typedemesure
    }

    onMesureClick = (mesure) => {
        this.setState({selectedId: mesure.id}, () => this.props.clickFunc(mesure))
    }

    onMesureMiddleClick = (mesure) => {
        this.props.spread(mesure)
    }

    toggleSkiacol = (measure) => {
        MesureStore.toggleSkiacol(measure).catch(error => {
            if (error.response.status === 400) toast.error(t("ACTIVE_TABS.MEASURE_ALREADY_EXISTS"))
        })
    }

    renderToggleSkiacol = (measure) => {
        const skiacolMeasures = [TypesMesures.AUTOREF_SKIACOL, TypesMesures.REF_SUBJ_SKIACOL]
        const skiacolableMeasures = [TypesMesures.AUTOREF, TypesMesures.REF_SUBJ]
        const isSkiacolable = skiacolableMeasures.includes(measure.titre)

        if(![...skiacolMeasures, ...skiacolableMeasures].includes(measure.titre)) return null

        return <a className="btn-flat btn-small grey lighten-4" onClick={() => this.toggleSkiacol(measure)}
                  style={{paddingInline: 5, textDecoration: isSkiacolable ? "line-through" : "none" }}
                  title={isSkiacolable ? "" + t("ACTIVE_TABS.SWITCH_TO_SKIACOL") : t("ACTIVE_TABS.SWITCH_TO_AUTOREF")}
        >
            SK
        </a>
    }

    render() {
        if (this.props.delete) {
            return (
                <div style={{display: "flex", flexDirection: "column"}}>
                    <h3 className="center">{t("ACTIVE_TABS.TYPE_OF_MEASUREMENT")}</h3>
                    <ul className="collection">
                        {MesureStore.existingMesures.map((mesure) => {
                            const type = mesure_types.find(type => TypesMesures[type.name] === mesure.titre)
                            const locked = mesure.titre === TypesMesures.REF_SUBJ && isLocked(LockingElement.LEFT_STENOPEIC_HOLE, LockingElement.RIGHT_STENOPEIC_HOLE)
                            return <li className="collection-item" key={mesure.id}
                                       onMouseEnter={() => this.setState({hoveredId: mesure.id})}
                                       onMouseLeave={() => this.setState({hoveredId: undefined})}
                                       onClick={() => this.onMesureClick(mesure)}
                                       onAuxClick={() => this.onMesureMiddleClick(mesure)}
                                       data-cy="ExistingMeasure"
                                       style={{
                                           display: "flex",
                                           alignItems: "center",
                                           padding: 0,
                                           cursor: "pointer",
                                           backgroundColor: MesureStore.typedemesure === mesure.id ? "#d1dfff" : this.state.hoveredId === mesure.id ? "#eeeeee" : ""
                                       }}
                            >
                                <div style={{
                                    width: "100%",
                                    margin: "10px 15px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                                     onClick={() => this.onMesureClick(mesure)}
                                     onAuxClick={() => this.onMesureMiddleClick(mesure)}
                                >
                                    <span className={locked ? "red-text" : "blue-text"}>
                                        {Helper.capitalizeFirstLetter(mesure.titre)}
                                    </span>
                                    <MesureOverview mesure={mesure} type={type}/>
                                </div>
                                {this.renderToggleSkiacol(mesure)}
                                {mesure.titre === "Tension" || mesure.titre === "Pachymétrie" ?
                                    <a className="secondary-content btn-flat btn-small transparent"
                                       onClick={(e) => {
                                           e.preventDefault();
                                           e.stopPropagation();
                                           this.props.delete(mesure)
                                       }}
                                       style={{marginInline: 0,marginBlock: "auto", paddingInline: 5}}
                                       data-cy="DeleteMeasureButton">
                                        <i className="material-icons">delete</i>
                                    </a>
                                    :
                                    <>
                                        <a className={`secondary-content btn-flat btn-small transparent ${this.props.type === "" ? "disabled" : ""}`}
                                           onClick={(e) => {
                                               e.preventDefault();
                                               e.stopPropagation();
                                               this.props.spread(mesure)
                                           }}
                                           style={{marginLeft: "auto", paddingInline: 5}}
                                           data-cy="DeleteMeasureButton">
                                            <i className="material-icons">arrow_circle_right</i>
                                        </a>
                                        <a className="secondary-content btn-flat btn-small transparent"
                                           onClick={(e) => {
                                               e.preventDefault();
                                               e.stopPropagation();
                                               this.props.delete(mesure)
                                           }}
                                           style={{marginInline: 0, marginBlock: "auto", paddingInline: 5}}
                                           data-cy="DeleteMeasureButton">
                                            <i className="material-icons">delete</i>
                                        </a>

                                    </>
                                }
                            </li>
                        })}
                    </ul>
                </div>
            );
        } else {
            const mesures = MesureStore.existingMesures.filter(mesure => !mesure_types.find(type => TypesMesures[type.name] === mesure.titre)?.unprescriptable)
            return (
                <div style={{display: "flex", flexDirection: "column"}}>
                    <h3 className="center">{t("ACTIVE_TABS.TYPE_OF_MEASUREMENT")}</h3>
                    {MesureStore.typedemesure ?
                        <div style={{height: "2.3em"}}></div> :
                        <h6 className="red-text center"
                            style={{marginBottom: "0.7em"}}>{t("ACTIVE_TABS.NO_TYPE_SELECTED")}</h6>
                    }
                    <div className="collection" style={{margin: 0}}>
                        {mesures.map((mesure) => {
                            const type = mesure_types.find(type => TypesMesures[type.name] === mesure.titre)
                            return <div key={mesure.id} style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: MesureStore.typedemesure === mesure.id ? "#d1dfff" : this.state.hoveredId === mesure.id ? "#eeeeee" : ""
                            }}
                                        onMouseEnter={() => this.setState({hoveredId: mesure.id})}
                                        onMouseLeave={() => this.setState({hoveredId: undefined})}
                                        onClick={() => {
                                            this.setState({selectedId: mesure.id}, () => {
                                                this.props.clickFunc(mesure)
                                            })
                                        }} className="collection-item">
                                <div style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                                     onClick={() => this.setState({selectedId: mesure.id}, () => this.props.clickFunc(mesure))}>
                                    <span className="blue-text"> {Helper.capitalizeFirstLetter(mesure.titre)}</span>
                                    <MesureOverview mesure={mesure} type={type}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            );
        }
    }
}

export default ActiveTabs
